import { WinnerTestimonial } from "../types";

interface WinnerCardProps extends WinnerTestimonial {}

export default function WinnerCard({ bannerImage, prizeImage, prize, name, memberType, date, quote }: WinnerCardProps) {
  return (
    <div className="flex flex-col relative w-full h-full mt-4 min-h-[346px] lg:min-h-[426px] pt-4 pb-5 lg:pb-8 px-4 lg:px-6 gap-5 lg:gap-6 bg-white rounded-lg lg:rounded-2xl shadow-[0px_1.5px_8px_0px_rgba(0,0,0,0.2)]">
      <img
        src="/assets/images/botb-pass/winner-badge.png"
        alt="BOTB Pass Winner"
        className="absolute -top-4 left-2 lg:left-0 z-10 size-12 lg:size-20"
      />

      {prizeImage && (
        <img
          src={prizeImage}
          alt="Winner prize"
          className="absolute object-cover rounded-full bg-gray-5 right-0 top-0 z-10 w-[94px] h-[97px] lg:w-[134px] lg:h-[138px]"
        />
      )}

      <div className="flex flex-col gap-2.5 lg:gap-4 relative">
        <div className="relative shrink-0 h-20 lg:h-[122px] bg-gray-11 rounded-lg overflow-visible">
          {bannerImage && (
            <img src={bannerImage} alt={`${name} winner`} className="w-full h-full object-cover rounded-lg" />
          )}
        </div>

        <p className="m-0 p-0 text-base lg:text-[18px] font-semibold font-jost leading-5.5 lg:leading-6 bg-gradient-botb bg-clip-text text-transparent truncate">
          {prize}
        </p>

        <hr className="m-0 p-0 border-0 border-t border-black/[0.08]" />

        <div className="flex flex-col gap-0.5 lg:gap-1">
          <p className="m-0 p-0 text-sm lg:text-[18px] font-medium font-jost lg:leading-6 text-black">{name}</p>
          <div className="flex items-center flex-wrap gap-1.5 lg:gap-2">
            <span className="text-[11px] lg:text-sm font-medium font-jost text-secondary whitespace-nowrap">
              {memberType}
            </span>
            <div className="shrink-0 size-1.5 lg:size-2 bg-secondary rounded-full" />
            <span className="text-[11px] lg:text-sm font-medium font-jost text-secondary whitespace-nowrap">
              {date}
            </span>
          </div>
        </div>
      </div>

      <div className="relative px-4 lg:px-6">
        <div className="absolute left-0 -top-[7px] lg:-top-[14px]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 91 46"
            fill="none"
            aria-hidden="true"
            className="w-[63px] lg:w-[91px] h-auto">
            <path
              d="M33.4007 46L0 45.8296L25.3914 0H49.7603L33.4007 46ZM74.6405 46L41.4101 45.8296L66.8015 0H91L74.6405 46Z"
              fill="black"
              fillOpacity="0.05"
            />
          </svg>
        </div>
        <div
          className="m-0 text-sm lg:text-base italic font-normal font-jost leading-6 lg:leading-7 text-gray-1"
          dangerouslySetInnerHTML={{ __html: quote }}
        />
      </div>
    </div>
  );
}
